import styled from "styled-components";
import { Input, ElementLight, ValidationState } from "../shared-style";

export const StyledInput = styled.input`
    ${Input}
    ${ElementLight}
    ${ValidationState}
`;

export const CardOptions = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 2;
    border-radius: 8px;
    border: 1px solid ${p => p.theme.c.disabled};
    background-color: ${p => p.theme.c.cardBackground};
    box-shadow: 1px 2px 4px 0 ${p => p.theme.c.blackShadow3};
    max-height: 254px;
    overflow-y: auto;

    &.Flipped {
        top: auto;
        bottom: calc(100% - 26px);
        box-shadow: 1px -2px 4px 0 ${p => p.theme.c.blackShadow3};
    }
`;

export const CardOption = styled.div`
    cursor: pointer;
    .TransformTarget {
        transition: 400ms;
    }
    transition: 400ms;
    border-bottom: 1px solid ${p => p.theme.c.disabled};
    &:last-child {
        border-bottom: none;
    }

    &:hover {
        background-color: ${p => p.theme.mode === "dark" ? p.theme.c.cardBackground : p.theme.c.light};
        .TransformTarget {
            transform: scale(1.1);
        }
    }
`;

export const SelectedValue = styled.div`
    position: relative;
    border: ${p => p.theme.mode === "dark" ? 0 : 1}px solid ${p => p.theme.c.disabled};
    background-color: ${p => p.theme.c.cardBackground};
    border-radius: 8px;
    overflow: hidden;
`;

export const Restart = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    font-size: 14px;
    font-weight: 300;
    color: ${p => p.theme.c.disabled};
    cursor: pointer;
`;

export const Unknown = styled(Restart)`
    color: ${p => p.theme.c.boost};
`;

export const CreateNewOption = styled.div`
    padding: 20px;
    cursor: pointer;
`;
